<template>
  <div class="profilePage">
    <app-navigation></app-navigation>
    <div class="profilePage--content">
      <router-view></router-view>
    </div>
      
  </div>
  
</template>

<script>
import Navigation from '../components/Navigation.vue'
export default {
  data() {
    return {
      name: ''

    }
  },
  components: {
    appNavigation: Navigation
  }
}
</script>

<style lang="scss" scoped>
  .profilePage {
    &--content {
      float: right;
      width: 80%;
      min-height: 100vh;
      background: #f1f1f1;
      overflow-x: scroll;
    }
  }
</style>
